<template>
  <div class="question-container">
    <div style="font-weight: 700; margin-bottom: 10px;">
      <span v-html="text"></span>
    </div>
    <div>
      <span class="text-bold" v-html="description"></span>
    </div>
    <Scale :num="5" :answer="answer" @sendAnswer="submitAnswer"/>
    <CommentBox :questionId="questionId" :key="commentKey"/>
  </div>

</template>

<script>
import CommentBox from './CommentBox.vue'
import Scale from './Scale.vue'
export default {
  name: 'Question',
  data() {
    return {
      answer: null,
      commentKey: 0
    }
  },
  components: {
    Scale,
    CommentBox
  },
  props: {
    text: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    order: {
      type: Number,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    }
  },
  computed: {
    answers: {
      get() {
        return this.$store.getters.answers
      },
      set(value) {
        this.$store.commit('setAnswers', value)
      }
    },
    barKey: {
      get() {
        return this.$store.getters.barKey
      },
      set(value) {
        this.$store.commit('setBarKey', value)
      }
    }
  },
  methods: {
    submitAnswer(val) {
      const obj = {
        questionId: this.questionId,
        comment: null,
        value: val
      }

      const activeSector = this.$store.getters.activeSector
      if (this.answers && this.answers[activeSector.id] != null) {
        const index = this.answers[activeSector.id].findIndex(q => q.questionId === this.questionId)
        if (index > -1) {
          this.answers[activeSector.id].splice(index, 1)
        }
        this.answers[activeSector.id].push(obj)
      }
      else {
        this.answers[[activeSector.id]] = []
        this.answers[[activeSector.id]].push(obj)
      }
      this.barKey++
      this.commentKey++
    }
  }
}
</script>

<style lang="scss" scoped>
  .question-container {
    margin-bottom: 20px;
  }
</style>
